import { drawLine } from "@gameApp/helpers/canvas/draw/line";
import { drawTextPure } from "@gameApp/helpers/canvas/draw/textPure";
import { getContextFont } from "@gameApp/helpers/canvas/getContextFont";
import { measureText } from "@gameApp/helpers/canvas/measureText";
import type {
  BasicDrawOptions,
  FontOptions,
} from "@gameApp/helpers/canvas/types";
import colors from "tailwindcss/colors";
import { LARGE_FONT_SIZE } from "../constants";

interface Params {
  context: CanvasRenderingContext2D;
  symbol: string;
  direction: string;
  period: string;
  startXY: [number, number];
}

export function miniGameOrderOverviewSnapshotDrawHeadline(
  params: Params,
): void {
  const { context, symbol, direction, period, startXY } = params;
  const [x, y] = startXY;
  const translateY = y;
  let translateX = x;

  translateX = drawTextWithSeparator({
    context,
    text: symbol,
    translateX,
    translateY,
    fontOptions: { size: LARGE_FONT_SIZE, weight: 600 },
    color: colors.white,
    withSeparator: true,
    separatorOptions: { lineWidth: 1, strokeStyle: colors.gray[500] },
  });

  translateX = drawTextWithSeparator({
    context,
    text: direction,
    translateX,
    translateY,
    fontOptions: { size: LARGE_FONT_SIZE, weight: 600 },
    color: direction === "UP" ? colors.green[500] : colors.red[500],
    withSeparator: true,
    separatorOptions: { lineWidth: 1, strokeStyle: colors.gray[500] },
  });

  drawTextWithSeparator({
    context,
    text: period,
    translateX,
    translateY,
    fontOptions: { size: LARGE_FONT_SIZE, weight: 600 },
    color: colors.white,
    withSeparator: false,
  });
}

function drawTextWithSeparator(params: {
  context: CanvasRenderingContext2D;
  text: string;
  translateX: number;
  translateY: number;
  fontOptions: FontOptions;
  color: string;
  withSeparator: boolean;
  separatorOptions?: BasicDrawOptions["contextOptions"];
}): number {
  const {
    context,
    text,
    translateX,
    translateY,
    fontOptions,
    color,
    withSeparator,
    separatorOptions,
  } = params;

  drawTextPure({
    context,
    text: text,
    x: translateX,
    y: translateY,
    contextOptions: {
      font: getContextFont(fontOptions),
      fillStyle: color,
    },
  });

  const { width: textWidth } = measureText(text, (ctx) => {
    ctx.font = getContextFont(fontOptions);
  });

  let nextX = translateX + textWidth + 6;

  if (withSeparator) {
    drawLine({
      context,
      startXY: [nextX, translateY - 12],
      endXY: [nextX, translateY - 12 + 16],
      contextOptions: separatorOptions,
    });

    nextX += 6;
  }

  return nextX;
}
